module.exports = __webpack_public_path__ + "img/H4.cda5e804.png";